import React, { useContext } from 'react';
import { ApiContext } from '../../../UseContext/ApiCall';
import { Modal } from 'react-bootstrap';
import Slider from 'react-slick';
import { AwsFileUrl } from '../../../../../config';


const HomePhotoVideoGridPopup = () => {

  const {
    setShowHomeVideoTagPopup,
    setHomeVideoAddedTags,

    showHomeGridPopup, setShowHomeGridPopup,
    homeGridPost,
    showHomeTagsOnPhoto, setShowHomeTagsOnPhoto,
  } = useContext(ApiContext);

  // handle click photo tag icon
  const handleClickPhotoTagIcon = (postId) => {
    setShowHomeTagsOnPhoto(prev => ({
      ...prev,
      [postId]: !prev[postId]
    }));
  };

  // handle click video tag icon
  const handleClickVideoTagIcon = (tags) => {
    setShowHomeVideoTagPopup(true);

    setHomeVideoAddedTags(tags);
  };

  
  // photo/video slider setting
  const photoVideoSetting = {
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: false,
    dots: true,
    // afterChange: (currentIndex) => {
    //   setActiveIndex(currentIndex);
    // },
  };

  // handle close popup
  const handleCloseHomePhotoVideoGridPopup = () => {
    setShowHomeGridPopup(false);
  };


  return (
    <>
      <Modal show={showHomeGridPopup} onHide={handleCloseHomePhotoVideoGridPopup} centered backdrop="static" keyboard={false} className="main-modal" >
      {/* <Modal show={true} onHide={handleCloseHomePhotoVideoGridPopup} centered backdrop="static" keyboard={false} className="main-modal" > */}
        <Modal.Header className='mb-3 pt-0' closeButton>
          <h5 className='flex-grow-1 text-center pt-3'>Grid</h5>
        </Modal.Header>

        <Modal.Body>
          <>
            {
              (homeGridPost && homeGridPost.photoVideo && homeGridPost.photoVideo.length > 0)
              &&
              <Slider className='home-photoVideo-slider border my-3' {...photoVideoSetting}>              
                {
                  homeGridPost.photoVideo.map((photoVideoValue, photoVideoIndex) => (
                    <div className='text-center position-relative' key={photoVideoIndex}>
                      {
                        photoVideoValue.fileUrl.includes('mp4')
                        ?
                        // Video
                        <>
                          <video src={AwsFileUrl+photoVideoValue.fileUrl} />

                          {/* tag Icon */}
                          <>
                            {
                              (photoVideoValue.tags.length > 0)
                              &&
                              <div className='position-absolute start-0 bottom-0 ms-2 mb-3 bg-secondary px-2 pb-1 rounded-circle cursor-pointer' onClick={() => handleClickVideoTagIcon(photoVideoValue.tags)}>
                                <img src="/images/icons/user-white.svg" style={{ height: '15px', width: '15px', cursor: 'pointer' }} alt="tag" />
                              </div>
                            }
                          </>
                        </>
                        :
                        // Photo
                        <>
                          <img 
                            src={photoVideoValue.fileUrl.includes('gif') ? photoVideoValue.fileUrl : AwsFileUrl+photoVideoValue.fileUrl} 
                            className={`object-fit-contain`} alt="photoVideo" 
                          />

                          {/* Tags */}
                          <>
                            {
                              (showHomeTagsOnPhoto[homeGridPost._id] && photoVideoValue.tags.length > 0)
                              &&
                              photoVideoValue.tags.map((tagValue, tagIndex) => (
                                <div className='position-absolute pt-1 px-2 bg-secondary rounded-2 d-flex align-items-center gap-2 text-white' key={tagIndex}
                                  style={{ 
                                    top: `${tagValue.offsetY}%`, 
                                    left: `${tagValue.offsetX}%`, 
                                    zIndex: `${tagIndex}`,
                                    fontSize: '13px',
                                    transform: 'translate(-50%, -0%)'
                                  }} 
                                >
                                  <span>{tagValue.userName}</span>
                                  {/* <span className='cursor-pointer'>✖</span> */}
                                </div>
                              ))
                            }
                          </>

                          {/* tag Icon */}
                          <>
                            {
                              (photoVideoValue.tags.length > 0)
                              &&
                              <div className='position-absolute start-0 bottom-0 ms-2 mb-3 bg-secondary px-2 pb-1 rounded-circle cursor-pointer' onClick={() => handleClickPhotoTagIcon(homeGridPost._id)} >
                                <img src="/images/icons/user-white.svg" style={{ height: '15px', width: '15px', cursor: 'pointer' }} alt="tag" />
                              </div>
                            }
                          </>
                        </>
                      }
                    </div>
                  ))
                }
              </Slider>
            }
          </>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default HomePhotoVideoGridPopup